// extracted by mini-css-extract-plugin
export var container = "_sb-0";
export var dotAnimation = "_sb-2";
export var dotsLoading = "_sb-1";